import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import { Link } from "react-router-dom";
import CampusEdit from "./campus-edit";
import CampusAdd from "./campus-add";
import EduPagination from "../edu-pagination/edu-pagination";
import DeleteModal from "../edu-helper/delete-modal";
import { toast, Bounce } from "react-toastify";

export default function CampusListTable() {
  let [campusData, setCampusData] = useState([]);
  let [deleteid, setDeleteid] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  let loginUser = JSON.parse(localStorage.getItem("user"));
  const [activateCampusAdd, setActivateCampusAdd] = useState(false);
  const [activateCampusEdit, setActivateCampusEdit] = useState(false);
  const [selectCampusRow, setSelectCampusRow] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(false);

  let CampusList = async () => {
    let response = await axios(
      `${baseUrl}/get_campus/?per_page=${pageLimit}&page=${pageNumber}`,
      {
        method: "GET",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      }
    );
    if (response?.status === 200) {
      setTotalCount(response?.data?.count || 0);
      setCampusData(response?.data?.data || []);
    }
  };

  useEffect(() => {
    try {
      (async function () {
        await CampusList();
      })();
    } catch (error) {
      setCampusData([]);
    }
  }, [forceUpdate, pageNumber]);

  let deleteHandle = async (id) => {
    let response;
    try {
      response = await axios(`${baseUrl}/delete_campus/${id}/`, {
        method: "DELETE",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
      });
      if (response?.status === 200) {
        setForceUpdate(!forceUpdate);
        toast.success("Edit Campus Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <>
      {/* <Header /> */}
      {/* <Sidebar activeItem={"BusManagement"} /> */}
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-chart-bar me-2" />
                College List
              </h4>
              <Link
                role="button"
                className="blu-btn"
                data-bs-toggle="modal"
                data-bs-target="#addcampus"
                onClick={() => setActivateCampusAdd(true)}
              >
                <i className="fa fa-plus me-2" />
                Add
              </Link>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    College List
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="cards bus-list">
              <div className="bus-filter">
                <div className="row justify-content-end">
                  <div className="col-lg-8">
                    {/* <form action="">
                      <div className="row justify-content-end">
                        {loginUser.user_type === "SUPER_ADMIN" && (
                          <div className="col-lg-4">
                            <select
                              name="company"
                              id=""
                              onChange={filterHandler}
                              className="form-select"
                              value={searchData.company}
                            >
                              <option value="">Select Company</option>
                              {companyNameData?.map((arr) => (
                                <option value={arr?.id} key={arr?.id}>
                                  {arr?.company_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                        <div className="col-lg-4">
                          <select
                            name="depo"
                            onChange={filterHandler}
                            className="form-select"
                            value={searchData?.depo}
                          >
                            <option value="">Select Depot</option>
                            {depoData?.map((arr) => (
                              <option key={arr?.id} value={arr?.id}>
                                {arr?.depo_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-2">
                          <button className="thm-btn w-100" onClick={() => {}}>
                            Submit
                          </button>
                        </div>
                        <div className="col-lg-3">
                          <select
                            name="cleaning_type"
                            onChange={filterHandler}
                            className="form-select"
                            // value={formval.user_type}
                          >
                            <option value="">Select Cleaning Type</option>
                            <option value="REGULAR_CLEANING">
                              Regular Cleaning
                            </option>
                            ;
                            <option value="STANDARD_DEEP_CLEANING">
                              Standard Deep Cleaning
                            </option>
                            <option value="ANNUAL_DEEP_CLEANING">
                              Annual Deep Cleaning
                            </option>
                          </select>
                        </div> 
                      </div>
                    </form> */}
                  </div>
                </div>
              </div>
              <div className="table table-responsive custom-table">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>College</th>
                      <th>Address</th>
                      <th>Company</th>
                      <th>Days</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {campusData?.length > 0 ? (
                      <>
                        {campusData?.map((arr, i) => {
                          return (
                            <tr key={arr.id}>
                              <td>{++i + pageLimit * (pageNumber - 1)}</td>
                              <td>
                                <span>{arr?.campus_name}</span>
                              </td>
                              <td>
                                <span>{arr?.campus_description}</span>
                              </td>
                              <td>
                                <span>{arr?.company?.name}</span>
                              </td>
                              <td>
                                {arr?.days?.map((day, index) => {
                                  return (
                                    <span
                                      key={index}
                                      className="badge bg-secondary me-1"
                                    >
                                      {day.substring(0, 3)}
                                    </span>
                                  );
                                })}
                              </td>
                              <td>
                                {(loginUser.user_type === "ADMIN_MANAGER" ||
                                  loginUser?.user_type ===
                                    "CLEANING_MANAGER") && (
                                  <Link
                                    role="button"
                                    className="btn btn-outline-warning"
                                    data-bs-toggle="modal"
                                    data-bs-target="#editcampus"
                                    onClick={() => {
                                      setActivateCampusEdit(true);
                                      setSelectCampusRow(arr);
                                    }}
                                  >
                                    <i className="fa fa-edit" />
                                  </Link>
                                )}
                                &nbsp;
                                <button
                                  className="btn btn-outline-danger"
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#deletemodal"
                                  onClick={() => setDeleteid(arr?.id)}
                                >
                                  <i className="fa fa-trash" />
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan="4">
                            <span>No data available</span>
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>

                <EduPagination
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  totalCount={totalCount}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <DeleteModal deleteHandle={deleteHandle} id={deleteid} />
      <CampusEdit
        selectCampusRow={selectCampusRow}
        setForceUpdate={setForceUpdate}
        forceUpdate={forceUpdate}
      />

      <CampusAdd setForceUpdate={setForceUpdate} forceUpdate={forceUpdate} />
    </>
  );
}
